import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageFrame } from '../../components';
import { fetchNewsArticles } from '../../services/api';
import './News.css';

function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadNews = async () => {
      setLoading(true);
      const { data, error } = await fetchNewsArticles();

      if (error) {
        console.warn('Failed to fetch news from API:', error);
        setArticles([]);
      } else {
        setArticles(data || []);
      }

      setLoading(false);
    };

    loadNews();
  }, []);

  const getTagClass = (tag) => {
    switch (tag) {
      case 'event': return 'news-tag event';
      case 'update': return 'news-tag update';
      case 'announcement': return 'news-tag announcement';
      default: return 'news-tag';
    }
  };

  if (loading) {
    return (
      <PageFrame>
        <header className="header">
          <div className="sword-divider">
            <span className="sword-line"></span>
            <span className="sword-icon">&#x1F4F0;</span>
            <span className="sword-line"></span>
          </div>
          <h1 className="page-title">Server News</h1>
          <p className="page-subtitle">Stay updated with the latest from Voxale</p>
        </header>
        <div className="news-loading">Loading news...</div>
      </PageFrame>
    );
  }

  return (
    <PageFrame>
      <header className="header">
        <div className="sword-divider">
          <span className="sword-line"></span>
          <span className="sword-icon">&#x1F4F0;</span>
          <span className="sword-line"></span>
        </div>
        <h1 className="page-title">Server News</h1>
        <p className="page-subtitle">Stay updated with the latest from Voxale</p>
      </header>

      {articles.length === 0 ? (
        <div className="news-empty">No news articles available at the moment.</div>
      ) : (
        articles.map((article, index) => (
          <React.Fragment key={article.id || article.slug}>
            {article.thumbnail ? (
              <article className="news-card">
                <div className="news-card-image">
                  <img src={article.thumbnail} alt={article.title} />
                </div>
                <div className="news-card-content">
                  <div className="news-article-header">
                    <span className="news-date">{article.date}</span>
                    <span className={getTagClass(article.tag)}>
                      {article.tag.charAt(0).toUpperCase() + article.tag.slice(1)}
                    </span>
                  </div>
                  <h2 className="news-article-title">{article.title}</h2>
                  <p className="news-excerpt">{article.excerpt}</p>
                  <Link to={`/news/${article.slug || article.id}`} className="btn btn-gold" style={{ marginTop: '1rem' }}>
                    Read More
                  </Link>
                </div>
              </article>
            ) : (
              <article className="news-article">
                <div className="news-article-header">
                  <span className="news-date">{article.date}</span>
                  <span className={getTagClass(article.tag)}>
                    {article.tag.charAt(0).toUpperCase() + article.tag.slice(1)}
                  </span>
                </div>
                <h2 className="news-article-title">{article.title}</h2>
                <p className="news-excerpt">{article.excerpt}</p>
                <Link to={`/news/${article.slug || article.id}`} className="btn btn-gold" style={{ marginTop: '1rem' }}>
                  Read More
                </Link>
              </article>
            )}
            {index < articles.length - 1 && <div className="news-divider"></div>}
          </React.Fragment>
        ))
      )}
    </PageFrame>
  );
}

export default News;
